<div class="row col-lg-12 col-md-12 col-sm-12 col-12">
  <div class="col-lg-10 col-md-10 col-sm-12 col-12 login-form">
    <div class="center-screen container-login100 bodybg-color">
      <p-card class="customCard">
        <p-header class="customHeader">
          <h3 class="text-center mt-0 m-b-15">
            <img src="/assets/v2/img/logo-color-baseline-V62-slogan-black.svg" alt="logo">
          </h3>
          <span class="headerTitle">
            S'authentifier
          </span>
        </p-header>
        <div class="row">
          <div class="col">
            <form [formGroup]="verifyCodeForm" (ngSubmit)="verifyCode()" action="#" novalidate>
              <div class="alert alert-danger" *ngIf="submitted && isError">
                Code invalide.
              </div>
              <div class="input-group form-group">
                <div class="row">
                  Valider votre code d'authentification à deux facteurs
                </div>
              </div>

              <div class="input-group form-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fa fa-keyboard"></i></span>
                </div>
                <input name="receivedToken" formControlName="receivedToken" [(ngModel)]="receivedToken" type="text"
                  class="form-control" placeholder="Code" maxlength="100" required="true"
                  [ngClass]="{ 'is-invalid':  submitted && f?.receivedToken.errors }">
              </div>
              <div class="row">
                <div class="col col-connect-action">
                  <button type="submit" class="btn btn-primary" (click)="verifyCode()">
                    <span class="btn-label">
                      <i class="pi pi-unlock"></i>
                    </span>Valider

                  </button>

                  <button type="button" class="btn btn-primary" (click)="backToSendCode()" style="margin-left: 10px;">
                    <span class="btn-label">
                      <i class="pi pi-arrow-left"></i>
                    </span>Retour
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</div>